import React from 'react';
import { Box, Stack } from '@mui/material';
import { CssTextField } from 'components/select';
import { useRecoilState } from 'recoil';
import ProvisioningStyles from 'pages/provisioning/day2-operation-paas/style';
import { isValidNotes, sspSubmitOrder } from 'pages/provisioning/store/day2-operation-paas';
import HelpImg from 'pages/provisioning/_components/helpImg';

const Notes = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [, setNotesValid] = useRecoilState(isValidNotes);
    const [showHelperText, setHelperText] = React.useState(false);
    const [showHelperMsg, setHelperMsg] = React.useState('');
    const handleValueChange = (value) => {
        if (value !== order?.notes) {
            setOrder({
                ...order,
                notes: value,
            });
        }
    };
    const validateInput = () => {
        if ((isTouched && order?.isTouched && !order?.notes) || showHelperText) {
            return 'validate';
        }
        return '';
    };
    React.useEffect(() => {
        if (!order?.notes && order?.isTouched) setIsTouched(true);
    }, [order?.notes, order?.isTouched]);
    React.useEffect(() => {
        if (order?.notes && !/^[a-zA-Z0-9-_ ]{3,255}$/.test(order?.notes)) {
            setNotesValid(true);
            setHelperText(true);
            setHelperMsg('Justification / Additional Info should be min. 3 to max. 255 chars only.');
        } else {
            setNotesValid(false);
            setHelperText(false);
            setHelperMsg('');
        }
    }, [order?.notes]);

    return (
        <Stack direction="row" sx={ProvisioningStyles.stack}>
            <CssTextField
                autoComplete="off"
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                label="Justification / Additional Info *"
                error={showHelperText}
                helperText={showHelperText && <span style={ProvisioningStyles.disposal.helpText}>{showHelperMsg}</span>}
                value={order?.notes || ''}
                onChange={(e) => handleValueChange(e?.target?.value)}
                className={validateInput()}
            />
            <Box sx={ProvisioningStyles?.helpImg}>
                <HelpImg title="Provide Additional Information" />
            </Box>
        </Stack>
    );
};

export default Notes;
